import { i18nFilter } from "app/filters/i18nFilter";
import { minVisitsAbbrFilter, numberFilter } from "app/filters/ngFilters";

export const MmxDataLegendTemplate = (props) => {
    if (!props.legendItems) {
        return null;
    }

    const item = props.legendItems[0];

    if (!item.showLegendData) {
        return <div className="legend-divider" />;
    }

    return (
        <div>
            <div
                className="u-blueMediumMedium big-number"
                title={numberFilter()(item.value)}
            >
                {minVisitsAbbrFilter()(item.value)}
            </div>
            <span className="graphtabs-tab-metric">{i18nFilter()(item.name)}</span>
        </div>
    );
};
